import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',

    primary: {
      main: '#2E7D32',
      light: '#66BB6A',
      dark: '#1B5E20',
      contrastText: '#FFFFFF',
    },

    secondary: {
      main: '#26A69A', // teal accent
    },

    background: {
      default: '#F4FBF6',
      paper: '#FFFFFF',
    },

    text: {
      primary: '#1B3A2B',
      secondary: '#4F6F5C',
    },

    divider: '#DDEFE3',

    success: {
      main: '#43A047',
    },

    warning: {
      main: '#FFB74D',
    },

    error: {
      main: '#EF5350',
    },

    info: {
      main: '#29B6F6',
    },
  },

  shape: {
    borderRadius: 14,
  },

  typography: {
    fontFamily: `'Kanit', 'Roboto', 'Arial', sans-serif`,
    h4: {
      fontWeight: 700,
      color: '#1B5E20',
    },
    h6: {
      fontWeight: 600,
    },
    subtitle1: {
      fontWeight: 600,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#F4FBF6',
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 8px 24px rgba(46, 125, 50, 0.08)',
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          paddingLeft: 20,
          paddingRight: 20,
        },
        containedPrimary: {
          boxShadow: '0 6px 16px rgba(46, 125, 50, 0.35)',
        },
        outlinedPrimary: {
          borderColor: '#2E7D32',
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: '#FFFFFF',
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2E7D32',
          },
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: '#FFFFFF',
        },
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: '#DDEFE3',
        },
      },
    },

    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: '#1B3A2B',
          boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        },
      },
    },

    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#E8F5ED',
          borderRight: '1px solid #DDEFE3',
        },
      },
    },

    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          margin: '4px 8px',
          '&.Mui-selected': {
            backgroundColor: '#C8E6C9',
            color: '#1B5E20',
            fontWeight: 600,
          },
          '&:hover': {
            backgroundColor: '#DFF2E5',
          },
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          fontWeight: 500,
        },
      },
    },
  },
});

export default theme;
